import { FR_LOCALE } from '@core/Constants/Locale.constants';
import { FR_PHONE_VALIDATION, UK_PHONE_VALIDATION } from '@core/Constants/Validations';
import { Locale } from '@core/Entities/Locale/Locale.entity';
import { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';

export const checkMinDate = (value: string) => {
  const dateValue = Number.isNaN(Date.parse(value))
    ? value
    : new Date(value).toISOString?.().split('T')[0];

  const minDateValue = new Date().toISOString?.().split('T')[0];
  const date = new Date(dateValue).getTime();
  const min = new Date(minDateValue).getTime();

  return date >= min;
};

export const checkMaxDate = (value: string) => {
  const dateValue = Number.isNaN(Date.parse(value))
    ? value
    : new Date(value).toISOString?.().split('T')[0];

  const today = new Date();
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 7);

  const date = new Date(dateValue).getTime();
  const max = new Date(maxDate.toISOString().split('T')[0]).getTime();
  return date <= max;
};

export const checkDealerOpenOnDate = (value?: string, vehicle?: Vehicle): boolean => {
  if (!vehicle || !vehicle.dealer || !vehicle.dealer.openingTimes || !value) {
    return true;
  }

  const date = new Date(value);
  const now = new Date();
  const dayOfWeek = date.getUTCDay();

  const openingTimes = vehicle.dealer.openingTimes;
  const openingTimesForDay = openingTimes.filter(
    openingTime => openingTime.dayOfWeek === dayOfWeek,
  );

  if (!openingTimesForDay.length) {
    return false;
  }

  if (date.toDateString() === now.toDateString()) {
    const latestClosingHour = openingTimesForDay
      .map(openingTime => {
        const [hours, minutes] = openingTime.openTo.split(':').map(Number);
        return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes).getTime();
      })
      .reduce((latest, current) => (current > latest ? current : latest), -Infinity);

    const currentTime = now.getTime();

    if (currentTime > latestClosingHour) {
      return false;
    }
  }

  return true;
};

export const isValidPhoneNumber = (value: string, locale: Locale): boolean => {
  if (locale === FR_LOCALE) {
    return FR_PHONE_VALIDATION.test(value);
  }
  return UK_PHONE_VALIDATION.test(value);
};

export const flattenObject = (
  obj: Record<string, any>,
  parentKey = '',
  result: Record<string, any> = {},
) => {
  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

    const value = obj[key];
    const newKey = parentKey ? `${parentKey}${key}` : key;

    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      flattenObject(value, '', result);
    } else {
      if (!Object.prototype.hasOwnProperty.call(result, newKey) || result[newKey] === undefined) {
        result[newKey] = value;
      }
    }
  }
  return result;
};

export const getItemsArray = (
  vehicle: Vehicle | undefined,
  values: Record<string, any>,
  similarVehicles: Vehicle[],
) => {
  if (!vehicle) return [];

  const additionalIds =
    values.oneClickChkBox || values.oneClickDriftrockChkBox
      ? similarVehicles
          .map(vhcl => vhcl.heycarId ?? vhcl.id)
          .filter(Boolean)
          .slice(0, 5)
      : undefined;

  return [
    {
      vehicle: {
        primary_id: vehicle?.heycarId,
        additional_ids: additionalIds,
      },
    },
  ];
};
